/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import TogglableContent from 'bundles/page/components/TogglableContent';
import CML from 'bundles/unified-description-page-common/components/shared/CML';
import ToggleButtonForTogglableContent from 'bundles/unified-description-page-common/components/shared/ToggleButtonForTogglableContent';

const COLLAPSED_HEIGHT = 78;

const styles = {
  container: css`
    margin-top: calc(var(--cds-spacing-200) * -1);
    white-space: pre-wrap;

    a {
      display: inline;
    }
  `,
  overrideStyles: css`
    .toggle-button-wrapper span {
      color: var(--cds-color-interactive-primary);
    }
  `,
};

type Props = {
  productId?: string;
  description?: string | null;
  cmlDescription?: CmlContent | null;
  trackingName?: string;
  ariaHidden?: boolean;
};

const TogglableDescription = ({ productId, description, cmlDescription, trackingName, ariaHidden }: Props) => {
  if (!description && !cmlDescription) {
    return null;
  }

  return (
    <div css={[styles.container, styles.overrideStyles]}>
      <TogglableContent
        ariaHidden={ariaHidden}
        childrenWrapperTag="div"
        className="about-section"
        collapsedHeight={COLLAPSED_HEIGHT}
        disableCollapseScroll
        renderToggleButtonContentFunction={ToggleButtonForTogglableContent}
        toggleButtonClassName="bold body-2-text"
        toggleButtonType="button"
        useSmartCollapse
        trackingName={trackingName ?? 'description'}
        {...(productId ? { trackingData: { courseId: productId } } : {})}
      >
        {cmlDescription ? <CML cml={cmlDescription} /> : description}
      </TogglableContent>
    </div>
  );
};

export default TogglableDescription;
